const initialState = {
  datos: {},
  count: {},
  loading: true,
  error: null,
  status: null,
  statusCount: null,
  loadingTable: false,
  filters: {
    date: {
      fechaStartFinal: null,
      fechaEndFinal: null
    },
    main: null
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/summary_truck/initialState.js